import React, { useRef, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { spacing, themeLight, breakpoints, mobile } from '@naf/theme';
import { Text, TextVariant } from '@naf/text';
import { propValidationConfig } from './propValidationConfig';
const textVariant = size => {
  switch (size) {
    case 'standard':
      return TextVariant.BlockquoteLarge;
    case 'small':
      return TextVariant.Blockquote;
    default:
      return TextVariant.BlockquoteLarge;
  }
};
export const Quote = ({
  children,
  className,
  size = 'standard',
  caption,
  href,
  link,
  advancedImage,
  img,
  negative = false
}) => {
  const bodyRef = useRef(null);
  const [lines, setLines] = useState(0);
  const [textSize, setTextSize] = useState(size);
  useEffect(() => {
    if (textSize === 'standard' && bodyRef && bodyRef.current) {
      const elementHeight = bodyRef.current.clientHeight;
      const lineHeight = 56;
      setLines(elementHeight / lineHeight);
    }
  }, [textSize]);
  useEffect(() => {
    if (lines && lines > 3) {
      setTextSize('small');
    }
  }, [lines]);
  return /*#__PURE__*/React.createElement(QuoteWrapper, {
    className: className,
    negative: negative
  }, /*#__PURE__*/React.createElement(QuoteSymbol, null, "\xAB"), /*#__PURE__*/React.createElement(QuoteText, {
    variant: textVariant(textSize),
    ref: bodyRef
  }, children), (img || advancedImage || caption || href) && /*#__PURE__*/React.createElement(DetailsWrapper, null, advancedImage && advancedImage, img && !advancedImage && /*#__PURE__*/React.createElement("img", {
    src: img.src,
    alt: img.alt
  }), /*#__PURE__*/React.createElement(Metadata, null, caption && /*#__PURE__*/React.createElement(Caption, {
    variant: TextVariant.ArticleTextHeader
  }, caption), href && !link && /*#__PURE__*/React.createElement(Link, {
    variant: TextVariant.ArticleText
  }, /*#__PURE__*/React.createElement("a", {
    href: href
  }, "Les mer")), link && /*#__PURE__*/React.createElement(Link, {
    variant: TextVariant.ArticleText
  }, /*#__PURE__*/React.createElement("a", {
    href: link.href
  }, link.text)))));
};
export default Quote;
const QuoteWrapper = styled.blockquote.withConfig(propValidationConfig).withConfig({
  displayName: "quote__QuoteWrapper",
  componentId: "sc-1k2uyp2-0"
})(["display:flex;flex-flow:column wrap;margin:0;width:764px;text-align:center;justify-content:center;@media (max-width:", "){width:528px;}@media (max-width:", "){width:327px;text-align:start;}p,a,h4,a:visited{color:", ";", "}a:hover{color:", ";}"], breakpoints.m, breakpoints.s, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, ({
  negative
}) => negative && css(["color:", ";"], ({
  theme
}) => theme.typography ? theme.typography.defaultTextInverted : themeLight.typography.defaultTextInverted), ({
  theme
}) => theme.typography ? theme.typography.textLink : themeLight.typography.textLink);
const QuoteSymbol = styled.i.withConfig({
  displayName: "quote__QuoteSymbol",
  componentId: "sc-1k2uyp2-1"
})(["min-width:100%;font-size:56px;font-weight:900;line-height:1;color:", ";@media (max-width:", "){font-size:40px;}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.extras.accent : themeLight.componentColors.extras.accent, breakpoints.s);
const QuoteText = styled(Text).withConfig({
  displayName: "quote__QuoteText",
  componentId: "sc-1k2uyp2-2"
})(["margin:0 !important;min-width:100%;@media (max-width:", "){", ";}@media (max-width:", "){", ";}"], breakpoints.m, mobile.article.blockquoteLarge, breakpoints.s, mobile.article.blockquote);
const DetailsWrapper = styled.div.withConfig({
  displayName: "quote__DetailsWrapper",
  componentId: "sc-1k2uyp2-3"
})(["display:flex;align-items:center;justify-content:center;margin-top:", ";text-align:start;min-width:100%;@media (max-width:", "){justify-content:flex-start;}div:nth-child(2){margin-left:", ";flex-direction:column;p:nth-child(2){margin-left:0;}}img{height:96px;width:96px;object-fit:cover;border-radius:50%;@media (max-width:", "){width:72px;height:72px;}}"], spacing.space16, breakpoints.s, spacing.space16, breakpoints.s);
const Metadata = styled.div.withConfig({
  displayName: "quote__Metadata",
  componentId: "sc-1k2uyp2-4"
})(["display:flex;margin:0;p:nth-child(2){margin-left:", ";}"], spacing.space16);
const Caption = styled(Text).withConfig({
  displayName: "quote__Caption",
  componentId: "sc-1k2uyp2-5"
})(["margin:0 !important;"]);
const Link = styled(Text).withConfig({
  displayName: "quote__Link",
  componentId: "sc-1k2uyp2-6"
})(["margin-top:0 !important;margin-bottom:0 !important;"]);
//# sourceMappingURL=quote.js.map